import * as yup from "yup";

export interface IAddress {
  key?: string;
  formatted_address?: string;
  street_number?: string;
  street?: string;
  postal_code?: string;
  municipality?: string;
  municipality_subdivision?: string;
  country_tertiary_subdivision?: string;
  country_secondary_subdivision?: string;
  country_subdivision?: string;
  country?: string;
  country_code?: string;
  position?: { latitude: number; longitude: number };
  viewport?: { west: number; south: number; east: number; north: number };
}

const positionSchema = yup.object().shape({
  latitude: yup.number().required(),
  longitude: yup.number().required(),
});

const viewportSchema = yup.object().shape({
  west: yup.number().required(),
  south: yup.number().required(),
  east: yup.number().required(),
  north: yup.number().required(),
});

export const addressSchema: yup.SchemaOf<IAddress> = yup.object({
  key: yup.string().optional(),
  formatted_address: yup.string().optional(),
  street_number: yup.string().optional(),
  street: yup.string().optional(),
  postal_code: yup.string().optional(),
  municipality: yup.string().optional(),
  municipality_subdivision: yup.string().optional(),
  country_tertiary_subdivision: yup.string().optional(),
  country_secondary_subdivision: yup.string().optional(),
  country_subdivision: yup.string().optional(),
  country: yup.string().optional(),
  country_code: yup.string().optional(),
  position: positionSchema.optional(),
  viewport: viewportSchema.optional(),
});
